import React from 'react';
import reviewsData from '../../data/reviews';
import MovieCard from '../../components/MovieCard';

const MyReviewPage = () => {
	if (!reviewsData || reviewsData.length === 0) {
		return (
			<div className="page-container">
				<h1 className="page-heading">My Personal Reviews</h1>
				<p style={{textAlign: 'center', fontSize: '1.3em', color: '#555', marginTop: '50px'}}>No reviews added yet. Start reviewing some movies or TV shows!</p>
			</div>
		);
	}

	// // Sort reviews by date, newest first (good for a blog-like feel)
	const sortedReviews = [...reviewsData].sort((a, b) => {
		if (!a.reviewDate && !b.reviewDate) return 0;
		if (!a.reviewDate) return 1;
		if (!b.reviewDate) return -1;
		return new Date(b.reviewDate) - new Date(a.reviewDate);
	});

	return (
		<div className="page-container">
			<h1 className="page-heading">My Personal Reviews</h1>
			<p style={{textAlign: 'center', fontSize: '1.1em', color: '#666', marginBottom: '40px', borderBottom: '1px solid #eee', paddingBottom: '15px'}}>Browse all my thoughts and ratings on movies and TV shows.</p>

			<div className="card-grid">
				{sortedReviews.map(review => (
					<MovieCard
						key={`${review.mediaType}-${review.id}`} // Unique key for each review
						movie={{
							id: review.id,
							media_type: review.mediaType,
							title: review.title, // For movies
							name: review.name, // For TV shows
							// poster_path: review.poster_path,
						}}
					/>
				))}
			</div>
			<p style={{textAlign: 'center', fontSize: '0.9em', color: '#888', marginTop: '40px', paddingTop: '20px', borderTop: '1px dashed #eee'}}>
				Note: Posters are dynamically fetched from TMDb based on the linked movie/TV show ID.
			</p>
		</div>
	)
}

export default MyReviewPage;